import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import type { JobList } from 'types/api'

export const jobsQueryKey = ['jobs']

type UsePlacesArgs = {
  searchParams: string
}

export function useJobs(args: UsePlacesArgs) {
  const { searchParams } = args

  const params = useMemo(
    function getParams() {
      const params = new URLSearchParams(searchParams)

      if (searchParams) {
        params.set('search', searchParams!)
      }

      return params
    },
    [searchParams]
  )

  async function getJobs() {
    const response = await apiClient.get<JobList[]>(
      SNA_PREFIX + `jobs?${params.toString()}`
    )

    return response.data
  }

  return useQuery({
    queryFn: getJobs,
    queryKey: [...jobsQueryKey, params.toString()]
  })
}
